/**
 * /how-it-works — the booking steps, with HowTo structured data.
 *
 * The words live in src/content/how-it-works.js and the layout lives in
 * src/components/HowItWorks. Nothing here but the route's entry point.
 *
 * See docs/ledgers/aeo/AEO-LEDGER.md, task 11b.
 */

import HowItWorks from '../components/HowItWorks';

const PageHowItWorks = () => <HowItWorks />;

export default PageHowItWorks;
